<div id="main">

  <!-- TOOLBAR: Above -->
  @if (fuseConfig.layout.toolbar.position === 'above' && showAppInterface) {
    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
  }
  <!-- / TOOLBAR: Above -->

  <div id="container-1" class="container">

    <!-- NAVBAR: Left -->
    @if (fuseConfig.layout.navbar.position === 'left' && showAppInterface) {
      <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
    }
    <!-- / NAVBAR: Left -->

    <div id="container-2" class="container">

      <!-- TOOLBAR: Below fixed -->
      @if (fuseConfig.layout.toolbar.position === 'below-fixed' && showAppInterface) {
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
      }
      <!-- / TOOLBAR: Below fixed -->

      <div #container3 id="container-3" class="container" fusePerfectScrollbar
        [fusePerfectScrollbarOptions]="{suppressScrollX: true, updateOnRouteChange : true}">

        <!-- TOOLBAR: Below static -->
        @if (fuseConfig.layout.toolbar.position === 'below-static' && showAppInterface) {
          <ng-container *ngTemplateOutlet="toolbar"></ng-container>
        }
        <!-- / TOOLBAR: Below static -->

        <!-- CONTENT -->
        <content></content>
        <!-- / CONTENT -->

        <!-- FOOTER: Below static -->
        @if (fuseConfig.layout.footer.position === 'below-static' && showAppInterface) {
          <ng-container *ngTemplateOutlet="footer"></ng-container>
        }
        <!-- / FOOTER: Below static -->

      </div>

      <!-- FOOTER: Below fixed -->
      @if (fuseConfig.layout.footer.position === 'below-fixed' && showAppInterface) {
        <ng-container *ngTemplateOutlet="footer"></ng-container>
      }
      <!-- / FOOTER: Below fixed -->

      @if (appService.hasNewVersion) {
        <mat-toolbar class="pl-24 mat-elevation-z1 accent fx-row fx-justify-start fx-items-center">
          <span class='mr-24'>Una nuova versione è disponibile, vuoi aggiornare la pagina ? </span>
          <a mat-icon-button href="javascript:window.location.reload(true)">
            <mat-icon>refresh</mat-icon>
          </a>
        </mat-toolbar>
      }

    </div>

    <!-- NAVBAR: Right -->
    @if (fuseConfig.layout.navbar.position === 'right' && showAppInterface) {
      <ng-container *ngTemplateOutlet="rightNavbar"></ng-container>
    }
    <!-- / NAVBAR: Right -->

  </div>

  <!-- FOOTER: Above -->
  @if (fuseConfig.layout.footer.position === 'above' && showAppInterface) {
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  }
  <!-- FOOTER: Above -->

</div>

<!-- QUICK PANEL -->
<fuse-sidebar name="quickPanel" position="right" class="quick-panel">
  <quick-panel></quick-panel>
</fuse-sidebar>
<!-- / QUICK PANEL -->

<!-- ASSISTENTE AI: pulsante flottante a destra + pannello laterale non modale -->
@if (showAppInterface) {
  <assistant-launcher></assistant-launcher>
  <assistant-panel></assistant-panel>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- @ PARTIALS
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- TOOLBAR -->
<ng-template #toolbar>
  @if (showBanner) {
    <div class="install_banner">
      <img src="assets/icons/icon-72x72.png" class="icon" />
      <span>
        Aggiungi l'applicazione sul tuo dispositivo per avere una migliore esperienza d'uso
        <a class="add_to_home" (click)='onInstallBtnClick()'>Aggiungi a schermata Home</a>
      </span>
      <!--<i class="fa fa-times"></i>-->
    </div>
  }
  @if (!fuseConfig.layout.toolbar.hidden) {
    <toolbar
      [ngClass]="fuseConfig.layout.toolbar.customBackgroundColor === true ? fuseConfig.layout.toolbar.position + ' ' + fuseConfig.layout.toolbar.background : fuseConfig.layout.toolbar.position">
    </toolbar>
  }
</ng-template>
<!-- / TOOLBAR -->

<!-- FOOTER -->
<ng-template #footer>
  @if (!fuseConfig.layout.footer.hidden) {
    <footer
      [ngClass]="fuseConfig.layout.footer.customBackgroundColor === true ? fuseConfig.layout.footer.position + ' ' + fuseConfig.layout.footer.background : fuseConfig.layout.footer.position">
    </footer>
  }
</ng-template>
<!-- / FOOTER -->

<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
  @if (!fuseConfig.layout.navbar.hidden) {
    <fuse-sidebar name="navbar" class="navbar-fuse-sidebar"
      [folded]="fuseConfig.layout.navbar.folded"
      lockedOpen="gt-md"
      >
      <navbar [variant]="fuseConfig.layout.navbar.variant" class="left-navbar"></navbar>
    </fuse-sidebar>
  }
</ng-template>
<!-- / LEFT NAVBAR -->

<!-- RIGHT NAVBAR -->
<ng-template #rightNavbar>
  @if (!fuseConfig.layout.navbar.hidden) {
    <fuse-sidebar name="navbar" position="right" class="navbar-fuse-sidebar"
      [folded]="fuseConfig.layout.navbar.folded"
      lockedOpen="gt-md"
      >
      <navbar [variant]="fuseConfig.layout.navbar.variant" class="right-navbar"></navbar>
    </fuse-sidebar>
  }
</ng-template>
<!-- / RIGHT NAVBAR -->
